import { CartTotalDisplayStyles } from "@insite/content-library/Components/CartTotalDisplay";
import { cartTotalStyles as reviewStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCartTotal";
import { cartTotalStyles as shippingStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingCartTotal";
import { totalStyles as invoiceStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsTotal";
import { orderApprovalDetailsTotalStyles as approvalStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsTotal";
import { orderConfirmationTotalStyles as confirmationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationTotal";
import { totalStyles as orderStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsTotal";
import { requisitionConfirmationTotalStyles as requisitionStyles } from "@insite/content-library/Widgets/RequisitionConfirmation/RequisitionConfirmationTotal";
import { savedOrderDetailsTotalStyles as savedOrderStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsTotal";
import getColor from "@insite/mobius/utilities/getColor";
import { cartTotalStyles as cartStyles } from "@solveindustrial/Overrides/Widgets/Cart/CartTotal";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css, StyledProps } from "styled-components";

const buildBorderWrapper = (container?: StyledProps<any>) => css`
    ${container}
    background-color: ${getColor(colorStrings.commonGlobalWhite)};
    border: 1px solid ${getColor(colorStrings.commonBorder)};
    padding: 24px;
    border-radius: 4px;

    ${mediaQueriesBP.minMD} {
        padding: 40px;
    }
`;

const buildResetTotalDisplay = (totalDisplayStyle?: CartTotalDisplayStyles): CartTotalDisplayStyles => ({
    ...totalDisplayStyle,
    container: {
        ...totalDisplayStyle?.container,
        css: css`
            ${totalDisplayStyle?.container?.css}
            &&& {
                background-color: transparent;
                margin-bottom: 16px;
                padding: 0;
            }
        `,
    },
    subtotalLabel: {
        ...totalDisplayStyle?.subtotalLabel,
        variant: "bodyBig" as "body",
        forwardAs: "span",
        weight: 700,
        lineHeight: 1.8,
    },
    subtotalValue: {
        ...totalDisplayStyle?.subtotalValue,
        variant: "bodyBig" as "body",
        forwardAs: "span",
        weight: 700,
        lineHeight: 1.8,
    },
});

/* Cart section */
cartStyles.containerWrapper = {
    css: css`
        ${buildBorderWrapper(cartStyles.containerWrapper?.css)}
    `,
};

cartStyles.cartTotal = {
    ...buildResetTotalDisplay(cartStyles.cartTotal),
};

/* Checkout Shipping section */
shippingStyles.container = {
    ...shippingStyles.container,
    css: css`
        ${buildBorderWrapper(shippingStyles.container?.css)}
    `,
};

shippingStyles.cartTotal = {
    ...buildResetTotalDisplay(shippingStyles.cartTotal),
};

/* Checkout Review section */
reviewStyles.container = {
    ...reviewStyles.container,
    css: css`
        ${buildBorderWrapper(reviewStyles.container?.css)}

        && {
            [data-test-selector*="cartTotal_"] {
                background-color: transparent;
                margin-bottom: 16px;
                padding: 0;
            }
        }
    `,
};

/* Order Confirmation section */
confirmationStyles.cartTotal = {
    ...confirmationStyles.cartTotal,
    container: {
        ...confirmationStyles.cartTotal?.container,
        css: buildBorderWrapper(confirmationStyles.cartTotal?.container?.css),
    },
};

/* Order detail section */
orderStyles.orderTotal = {
    ...orderStyles.orderTotal,
    container: {
        ...orderStyles.orderTotal?.container,
        css: buildBorderWrapper(orderStyles.orderTotal?.container?.css),
    },
};

/* Approval detail section */
approvalStyles.cartTotal = {
    ...approvalStyles.cartTotal,
    container: {
        ...approvalStyles.cartTotal?.container,
        css: buildBorderWrapper(approvalStyles.cartTotal?.container?.css),
    },
};

/* Saved order detail section */
savedOrderStyles.cartTotal = {
    ...savedOrderStyles.cartTotal,
    container: {
        ...savedOrderStyles.cartTotal?.container,
        css: buildBorderWrapper(savedOrderStyles.cartTotal?.container?.css),
    },
};

/* Invoice section */
invoiceStyles.container = {
    ...invoiceStyles.container,
    css: buildBorderWrapper(invoiceStyles?.container?.css),
};

/* Requisition section */
requisitionStyles.cartTotal = {
    ...requisitionStyles.cartTotal,
    container: {
        ...requisitionStyles.cartTotal?.container,
        css: buildBorderWrapper(requisitionStyles.cartTotal?.container?.css),
    },
};
